import { render, staticRenderFns } from "./UserChart2.vue?vue&type=template&id=a023ddb8&"
import script from "./UserChart2.vue?vue&type=script&lang=js&"
export * from "./UserChart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports